import { Box, Image, motion } from '@hover/blueprint';
import { useAnimation } from 'framer-motion';
import React, { useEffect } from 'react';

import SelectHouseElementGif from 'src/assets/img/interactiveRendering/select-house-element.gif';

export const HelpOverlay = ({
  onAnimationDone,
}: {
  onAnimationDone: () => void;
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
  const boxAnimation = useAnimation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call
  const imageAnimation = useAnimation();

  useEffect(() => {
    void (async () => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      await boxAnimation.start(
        { transform: 'translate(-50%, -50%) translateY(0px)', opacity: 1 },
        { duration: 0.45, ease: [0, 0, 0.1, 1] },
      );

      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      await imageAnimation.start(
        { opacity: 1 },
        { duration: 0.15, ease: 'easeOut' },
      );

      await new Promise<void>(resolve => {
        setTimeout(() => resolve(), 8700);
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
      await boxAnimation.start(
        { transform: 'translate(-50%, -50%) translateY(40px)', opacity: 0 },
        { duration: 0.45 },
      );

      onAnimationDone();
    })();
  }, [imageAnimation, boxAnimation, onAnimationDone]);

  return (
    <Box
      animate={
        boxAnimation /* eslint-disable-line @typescript-eslint/no-unsafe-assignment */
      }
      as={motion.div}
      backgroundColor="#000"
      borderRadius={500}
      initial={{
        transform: 'translate(-50%, -50%) translateY(40px)',
        opacity: 0,
      }}
      left="50%"
      overflow="hidden"
      position="absolute"
      top="50%"
    >
      <Image
        alt="Click an area of your home to begin"
        animate={
          imageAnimation /* eslint-disable-line @typescript-eslint/no-unsafe-assignment */
        }
        as={motion.img}
        initial={{ opacity: 0 }}
        src={SelectHouseElementGif}
      />
    </Box>
  );
};
